import { useEffect } from "react";
import ItemInfoCards from "./itemInfoCards";
import QATable from "./qaTable";
import { useTabsContext } from "../../../contexts/tabsContext";
import { useFetchData as useGetData } from "../../../hooks/useFetch/get";
import { App, Spin } from "antd";
import { useCommonPropertiesContext } from "../../../contexts/commonPropertiesContext";
import { ContainerWrapper } from "../../../app/app.style";
import { LoadingOutlined } from '@ant-design/icons';

const QAManager = () => {

	const { message: messageApi } = App.useApp();
	
	const { id } = useTabsContext();
	const { currentBatch, choosedBatchToQA, setChoosedBatchToQA } = useCommonPropertiesContext()

	const [fetchItemById, {
		data: itemByIdData,
		isLoading: loadingItemByIdData,
		error,
		clearError
	}] = useGetData({
		query: "/@batch/items/@_id",
		selectData: (data) => data
	})

	const [fetchAttributesData, {
		data: attributesData,
		error: attributesError,
		clearError: clearAttributesError,
		clearData: clearAttributesData
	}] = useGetData({
		query: "/classes/@className/attributes",
		selectData: (data) =>
			[...data.items]
				.sort((a, b) =>
					a.attr_code.localeCompare(b.attr_code))
				.map((attr, index) => {
					let attrCode = attr.attr_code;

					const llmValues = itemByIdData.extractions?.[attrCode] || [];
					const final = itemByIdData.finals?.[attrCode];

					const isMandatory = attr.required === "Required"

					return {
						key: index,
						attribute: attr,
						isMandatory,
						llmExtractionValues:
							llmValues.length > 0
								? llmValues.map((v) => v.value).join(", ")
								: "-",
						finalValue: final ? final.value : "-",
					}
				})
	})

	useEffect(() => {
		if (id) {
			fetchItemById({ "batch": choosedBatchToQA, "_id": id })
		}
	}, [id])

	useEffect(() => {
		if (itemByIdData?.class_name) {
			fetchAttributesData({ "className": itemByIdData.class_name })
		} else {
			clearAttributesData();
		}
	}, [itemByIdData])

	useEffect(() => {
		if (error) {
			messageApi.error(error.message);
			clearError?.();
		}
	}, [error, messageApi])

	useEffect(() => {
		if (attributesError) {
			messageApi.error(attributesError.message);
			clearAttributesError?.();
		}
	}, [attributesError, messageApi])

	const handleClickReload = () => {
		fetchItemById({ "batch": currentBatch, "_id": id })
		setChoosedBatchToQA(currentBatch)
	}

	return (
		<ContainerWrapper $paddingMode="top">
			<Spin indicator={<LoadingOutlined />} spinning={loadingItemByIdData} size="large">
				<ItemInfoCards
					metadataInfo={itemByIdData}
					handleClickReload={handleClickReload}
					currentBatch={currentBatch}
				/>
				<QATable
					metadataInfo={itemByIdData}
					tableData={attributesData}
					fetchItemById={fetchItemById}
				/>
			</Spin>
		</ContainerWrapper>
	)
}

export default QAManager;